const taskTypes = Object.freeze({
  bothClassrooms: 'both_classrooms',
  classroomA: 'classroom_a',
  partnerB: 'partner_b'
});

export default taskTypes
